import { Address } from "./IAddress";
import {
    IAddress,
    IFile,
    IOtherInformation,
    IStoreHours,
    IStoreSales,
    IStoreWorkflow,
} from "./Models";
import { IStoreType, StoreType } from "./IStoreType";
import { IGeocodeResponse } from "./IGeocodeResponse";

export interface IStore {
  displayLabel: string;
  lid: number;
  storeTypeID: number;
  storeNumber: string;
  storeName: string;
  openDate: string;
  closeDate: any;
  ssid: number;
  iconPath: string;
  actualSales: number;
  actualVolume: number;
  squareFeet: number;
  tradeAreaOverall: number;
  tradeAreaType: string;
  website: string;
  phone: string;
  fax: string;
  email: string;
  targetSales: number;
  employeeCount: number;
  managerCount: number;
  salesMargin: number;
  readonly modifiedDate: Date;
  readonly modifiedDateString: string;
  workflow: IStoreWorkflow;
  readonly googlePlaceID: string;
  readonly bingPlaceID: string;
  comments: string;
  proformaSales: number;
  regionCode: any;
  budsCurrent: number;
  buds: number;
  budsLabel: string;
  createdByUserID: number;
  hours: IStoreHours;
  image: string;
  otherInformation: Array<IOtherInformation> /* List */;
  sales: Array<IStoreSales> /* List */;
  files: Array<IFile> /* List */;
  forecastValue: number;
  forecastComments: string;
  forecastDate: Date;
  serverVerified: boolean;
  totalUniqueHouseholds: number;
  totalHouseholdSpend: number;
  id: number;
  uniqueID: string;
  name: string;
  isActive: boolean;
  type: string;
  readonly cid: number;
  latitude: number;
  longitude: number;
  displayValue: number | null /* nullable */;
  address: IAddress;
  typeID: number;
  model?: any;
  formattedAddress: string;
  storeType: IStoreType;
  geocodeResult: IGeocodeResponse;
}

export class Store implements IStore {
  public id = 0;
  public cid = 0;
  public lid = 0;
  public uniqueID = null;
  public name = "";
  public comments = "";
  public storeTypeID = 0;
  public typeID: 0;
  public forecastDate = new Date();
  public serverVerified = null;
  public totalUniqueHouseholds = 0;
  public totalHouseholdSpend = 0;
  public storeNumber = "";
  public isActive = true;
  public forecastComments = "";
  public openDate = null;
  public storeName = "";
  public forecastValue = 0;
  public closeDate = null;
  public ssid = 0;
  public actualSales = 0;
  public actualVolume = 0;
  public address: IAddress = new Address();
  public address1 = "";
  public address2 = "";
  public address3 = "";
  public city = "";
  public state = "";
  public zip = "";
  public zip4 = "";
  public country = "";
  public regionCode = null;
  public budsCurrent = null;
  public squareFeet = 0;
  public tradeAreaOverall = null;
  public tradeAreaType = null;
  public latitude = 0;
  public longitude = 0;
  public website = null;
  public phone = null;
  public fax = null;
  public email = null;
  public targetSales = 0;
  public employeeCount = 0;
  public managerCount = 0;
  public sales = [];
  public salesMargin = 0;
  public modifiedDate = new Date();
  public modifiedDateString = "";
  public workflow = null;
  public dataset = null;
  public googlePlaceID = "";
  public bingPlaceID = "";
  public commments = null;
  public image = null;
  public iconPath: "";
  public proformaSales = 0;
  public hours = null;
  public otherInformation = [];
  public displayLabel = "";
  public displayValue = null;
  public files = [];
  public formattedAddress = "";
  public storeType = new StoreType();
  public friendlyOpenDate = "";
  public orderIndex = 0;
  public model = null;
  public type = "Store";
  public buds = null;
  public budsLabel = "";
  public createdByUserID = null;
  public geocodeResult = null;
}
